import { useMutation, useQueryClient } from 'react-query';
import { postAttendance } from '../../services/apis/AttendanceApi';

const useAttendanceMutation = () => {
	const queryClient = useQueryClient();

	return useMutation((data) => postAttendance({ body: data }), {
		onSuccess: (data) => {
			// 페이징 쿼리도 같이 refetch
			console.log('useAttendanceMutation data', data);
			queryClient.refetchQueries('attendancePaging');
			queryClient.refetchQueries('attendance');
			return data;
		},
		onError: (error, data) => {
			console.error('Attendance mutation error:', error, data);
			return false;
		},
	});
};

export default useAttendanceMutation;
